import "./EmojiReaction.css";
import "../../css/Tooltip.css";
import classNames from "classnames";

export const ReactionVariant = {
    Like: "like",
    Dislike: "dislike",
} as const;

export type ReactionVariant = (typeof ReactionVariant)[keyof typeof ReactionVariant];

type Props = {
    emoji: string;
    tooltip: string;
    variant?: ReactionVariant | null | undefined;
};

function EmojiReaction({ emoji, tooltip, variant }: Props) {
    let variantStyle: string;
    switch (variant) {
        case ReactionVariant.Like:
            variantStyle = "emoji-reaction__border-green";
            break;
        case ReactionVariant.Dislike:
            variantStyle = "emoji-reaction__border-red";
            break;
        default:
            variantStyle = "emoji-reaction__border-neutral";
            break;
    }
    return (
        <div
            className={classNames(
                "emoji-reaction web-lib__tooltip web-lib__tooltip--top",
                variantStyle,
            )}
            data-tooltip={tooltip}
        >
            <div className="emoji-reaction__emoji">{emoji}</div>
        </div>
    );
}

export default EmojiReaction;

export function LikeEmoji() {
    return (
        <EmojiReaction
            emoji="👍"
            tooltip="I like this"
            variant={ReactionVariant.Like}
        />
    );
}

export function DislikeEmoji() {
    return (
        <EmojiReaction
            emoji="👎"
            tooltip="I dislike this"
            variant={ReactionVariant.Dislike}
        />
    );
}
